import { Button, Modal } from 'antd'
import React from 'react'

const DeleteProductModal = ({ isOpen, handleClose, handleDelete, product, loading }) => {
    return (
        <Modal
            title="Delete Product"
            open={isOpen}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose}>
                    Cancel
                </Button>,
                <Button
                    key="delete"
                    type="primary"
                    danger
                    onClick={() => handleDelete(product?.id)}
                    loading={loading}
                >
                    Delete Product
                </Button>
            ]}
            width={400}
        >
            <div className="space-y-4">
                <div className="flex items-center gap-3">
                    <div className="flex-shrink-0">
                        <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                    <div>
                        <h3 className="text-lg font-medium text-gray-900">Are you sure?</h3>
                        <p className="text-sm text-gray-500 mt-1">
                            This action cannot be undone. "{product?.name}" will be permanently deleted.
                        </p>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteProductModal